import { motion, AnimatePresence } from 'framer-motion'

interface ConfirmDialogProps {
  open: boolean
  title?: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  tone?: 'coral' | 'sage'
  onConfirm: () => void
  onCancel: () => void
}

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'coral',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onCancel}
            className="fixed inset-0 bg-warmblack/40 z-[60]"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.92 }}
            transition={{ type: 'spring', damping: 22, stiffness: 320 }}
            className="fixed inset-0 z-[61] flex items-center justify-center px-6 pointer-events-none"
          >
            <div className="bg-cream rounded-2xl shadow-2xl px-6 py-5 max-w-sm w-full pointer-events-auto">
              {title && (
                <h3 className="font-display text-xl font-bold text-warmblack mb-2">{title}</h3>
              )}
              <p className="font-body text-base text-warmblack/80 mb-5">{message}</p>
              <div className="flex gap-2 justify-end">
                <button
                  onClick={onCancel}
                  className="bg-warmblack/10 hover:bg-warmblack/15 text-warmblack font-display font-bold px-4 py-2 rounded-xl transition-colors"
                >
                  {cancelLabel}
                </button>
                <button
                  onClick={onConfirm}
                  className={`${
                    tone === 'sage'
                      ? 'bg-sage hover:bg-sage/90 text-warmblack'
                      : 'bg-coral hover:bg-coral/90 text-white'
                  } font-display font-bold px-4 py-2 rounded-xl shadow-sm transition-colors`}
                >
                  {confirmLabel}
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}
